import React from 'react';

export default function BlueLine(props) {
  return <div className={props.classes + " mx-auto h-1 bg-gradient-to-r from-teal-600 via-sky-600 to-indigo-700 shadow-2xl"} data-aos="fade-right" data-aos-delay={props.loadDelay}></div>
}